import { keyToModifiedKeyMap } from "@/components/MyStudents/Submissions/components/SubmissionsInformation/components/JsonTreeView/constants.ts";
import type { DataVal } from "./types";

export const convertToDisplayNodes = (key: string, value: object | Array<object> | string | undefined): DataVal => {
  let modifiedKey = keyToModifiedKeyMap[key];
  if (!modifiedKey) {
    modifiedKey = key
      .split("_")
      .join(" ")
      .split(/(?<![A-Z])(?=[A-Z])/)
      .join(" ")
      .toLowerCase();
  }

  if (Array.isArray(value)) {
    const children = value.map((element, index) => convertToDisplayNodes(`item ${(index + 1).toString()}`, element));
    return {
      name: modifiedKey,
      children: children,
    };
  }

  if (typeof value === "object") {
    const children = Object.entries(value).map(([childKey, childValue]) =>
      convertToDisplayNodes(childKey, childValue),
    );
    return {
      name: modifiedKey,
      children: children,
    };
  }

  return {
    name: modifiedKey,
    value: value === "null" || !value ? "N/A" : value,
    children: undefined,
  };
};
